var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      staticClass: "fill-height"
    },
    [
      _c(
        "v-tabs",
        {
          staticClass: "fill-height",
          attrs: {
            "hide-slider": "",
            grow: !_vm.$vuetify.breakpoint.xsOnly,
            "show-arrows": "",
            color:
              _vm.focused && _vm.$store.state._User.connexionType != "freshdesk"
                ? "accent"
                : _vm.focused &&
                  _vm.$store.state._User.connexionType == "freshdesk"
                ? "grey lighten-2"
                : "grey lighten-4",
            dark:
              _vm.focused && _vm.$store.state._User.connexionType != "freshdesk"
          },
          model: {
            value: _vm.tab.href,
            callback: function($$v) {
              _vm.$set(_vm.tab, "href", $$v)
            },
            expression: "tab.href"
          }
        },
        [
          _vm._l(_vm.filteredItems, function(item) {
            return _c(
              "v-tab",
              {
                key: item.href,
                attrs: {
                  href: "#" + item.href,
                  disabled: item.disabled.status,
                  title: item.title
                },
                on: {
                  click: function($event) {
                    return _vm.checkTab(item)
                  }
                }
              },
              [
                _c(
                  "v-icon",
                  {
                    attrs: {
                      size: "24",
                      color:
                        _vm.tab.href === item.href
                          ? "secondary"
                          : item.disabled.status
                          ? "grey"
                          : _vm.focused &&
                            _vm.$store.state._User.connexionType !== "freshdesk"
                          ? "white"
                          : "grey darken-2"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item.icone) + "\n      ")]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.itemsMenu, function(item) {
            return _c(
              "v-tab-item",
              {
                directives: [{ name: "bar", rawName: "v-bar" }],
                key: item.href,
                ref: "tab-item-" + item.href,
                refInFor: true,
                staticClass: "vb fill-height",
                attrs: { value: item.href }
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "contentFicheVisiteur",
                    class: {
                      "cobrowsing--container":
                        item.href == "mirroring" || item.href == "cobrowsing"
                    },
                    attrs: {
                      flat: "",
                      height: "100%",
                      width: "calc(100% - 20px)"
                    }
                  },
                  [
                    _vm.tab.href === item.href && item.show
                      ? _c(item.component, {
                          tag: "component",
                          staticClass: "fill-height tab-item__component",
                          attrs: {
                            datasVisiteur: _vm.datasVisiteur,
                            datasPupitreVisiteur: _vm.datasPupitreVisiteur,
                            params: "visId=" + _vm.datasVisiteur.visiteurID,
                            toolbar: true,
                            navigation: true,
                            chatHeight: "100%",
                            numChatsTotal: "0",
                            type: "chatting",
                            colorChatAgent: "grey lighten-1",
                            colorChatVisiteur: "grey",
                            hauteurDiv: _vm.hauteurDiv,
                            openOnMounted: ""
                          },
                          on: {
                            "update:hauteurDiv": function($event) {
                              _vm.hauteurDiv = $event
                            },
                            "update:hauteur-div": function($event) {
                              _vm.hauteurDiv = $event
                            },
                            closeCobrowsing: function($event) {
                              _vm.annuleCobrowsing()
                              _vm.tab = _vm.itemsMenu[0]
                            },
                            closeDialog: function($event) {
                              _vm.tab = _vm.itemsMenu[0]
                            },
                            startVisioAPZ: _vm.startVisio,
                            stopVisioAPZ: _vm.stopVisio,
                            cacheInfosVisiteur: function($event) {
                              return _vm.cacheInfosVisiteur()
                            },
                            put: function(msg) {
                              return _vm.$emit("update:msg", msg)
                            },
                            send: function(msg) {
                              return _vm.$emit("sendMsg", msg)
                            },
                            pushproduct: function(msg) {
                              return _vm.$emit("sendMsg", msg)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.xsOnly
            ? _c(
                "v-btn",
                {
                  staticClass: "btnCloseFicheInfos",
                  attrs: { icon: "", small: "" },
                  on: {
                    click: function($event) {
                      return _vm.cacheInfosVisiteur()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { large: "" } }, [
                    _vm._v("arrow_circle_right")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogDemandeCobrowsing,
            callback: function($$v) {
              _vm.dialogDemandeCobrowsing = $$v
            },
            expression: "dialogDemandeCobrowsing"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("titleAskCobrowsing")))]
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " + _vm._s(_vm.txtDemandeCobrowsing) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue--text darken-1",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.annuleCobrowsing()
                          _vm.tab = _vm.itemsMenu[0]
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.txtBtCobrowsing) + "\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e18138e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e18138e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzContentInfosVisiteur.vue
// module id = null
// module chunks = 